import { Component, OnInit } from '@angular/core';
import { KpiType } from 'src/app/shared/models/kpi.model';

@Component({
  selector: 'app-latency-bar',
  templateUrl: './latency-bar.component.html',
  styleUrls: ['./latency-bar.component.scss']
})
export class LatencyBarComponent implements OnInit {
  kpiType = KpiType.Latency;

  constructor() { }

  ngOnInit() {
  }

}
